import ko from '@tko/build.knockout';
import _ from 'lodash';
import crossroads from 'crossroads';
import hasher from 'hasher';
import moment from 'moment';
import LoginService from '../services/login.service';
import MessageService from "../services/message.service";

export default function Router(config, dataProvider) {
    var self = this;
    var currentRoute = this.currentRoute = ko.observable({});

    this.dataProvider = dataProvider;

    ko.utils.arrayForEach(config.routes, function(route) {
        // allow optional walkme GET params to be passed into the route UI-1252
        if (typeof route.url === 'string'            ) { // if it's a RegEx we can't easily add to it globally so only for strings
            if (!_.includes(route.url, ':?query:')) {
                route.url += ':?query:';
            }
        }
        crossroads.bypassed.add(function(request){
            location.href = '#';
        });
        crossroads.addRoute(route.url, function (requestParams) {
            //copy over page, view and any other properties from route object defined in startup.js
            var routeParams = ko.utils.extend(requestParams, route.params);

            if (_.isString(routeParams.redirect) && routeParams.redirect.length > 0) {
                // There are catch-all routes that will redirect to the closest root level app, or to the default URL.
                // If we get here is because the matching route was one of the catch-all routes.
                // e.g. /historical2/somebadurl -> /historical2/dashboard, etc.
                location.replace('#' + routeParams.redirect);
                routeParams.request_ = routeParams.redirect;
                // this was a bad URL
                // todo clear last url here when we add that functionality back in
                //for activity tracking and storing last location
                self.dataProvider.beforeRouting(routeParams, false);
                return;
            }

            if (routeParams.regexGroups) {
                // this is a route with a regular expression pattern, inject regex groups as named parameters
                // Example:
                //      url: /historical2\/meetings\/(\d+)\/params\/(.+)/, regexGroups: ['tabId', 'params']
                //      - (\d+) is injected as tabId
                //      - (.+) is injected as params
                _.forEach(route.params.regexGroups, function(groupName, index) {
                    routeParams[groupName] = requestParams[index];
                });
            }

            //if request is not for login, logout or register, ensure there is a valid logged in session
            if ((routeParams.request_ === '')
                || LoginService.isLoginPage()) {
                //if login page is reached as a result of redirect (the lines under 'else' below), prevURL will have a value; store it in routeParams to use later (in login-widget.js) to redirect
                routeParams = ko.utils.extend(routeParams, { prevURL: self.prevURL });

                self.dataProvider.beforeRouting(routeParams, true);
                //set the currentroute observable
                if (!routeParams.view) { // gigantic hack to resolve knockout observable issue with #login/su/.../url/...
                    routeParams = ko.utils.extend(routeParams, { view: currentRoute().view });
                }
              MessageService.notifyParentIframe(routeParams);
                currentRoute(routeParams);
            } else {
                //capture current request as prevURL to be used for redirect if we need to login (lines above)

                if (self.prevURL) {
                    routeParams = ko.utils.extend(routeParams, { prevURL: self.prevURL });
                }

                self.prevURL = routeParams.request_;

                LoginService.getActiveSession().then(function(userObject) {
                    //for activity tracking and storing last location
                    self.dataProvider.beforeRouting(routeParams, false);
                    let tosRedirect = false;
                    if ( !(sessionStorage.getItem('tosSkip') === 'true') && (userObject.email !== 'support@vyopta.com' && !_.startsWith(userObject.email, 'vyoptaadmin@')) && 
                      (!userObject.consentJson || (moment(new  Date(userObject.consentJson.timestamp.split('T')[0])).isBefore(moment('2025-10-07', 'YYYY-MM-DD'))))) {
                        if (requestParams.request_ !== 'termsOfService') {
                          location.href = '#termsOfService';
                          tosRedirect = true;
                        }
                    } else if (requestParams.request_ === 'termsOfService') {
                        location.href = routeParams.prevURL || self.dataProvider.getDefaultLocation();
                        tosRedirect = true;
                    }
                    
                    if (!location.href.includes('termsOfService') && !location.href.includes('hideIntercom=yes')) {
                      LoginService.setupPendo(); // this short circuits if it's already setup
                    }

                    if (!tosRedirect) {
                      if (self.dataProvider.isRoutePermitted(routeParams)) {
                        var oldReq = routeParams.request_;
                        if (oldReq === routeParams.request_) {
                          if (!routeParams.view) { // gigantic hack to resolve knockout observable issue with #login/su/.../url/...
                            routeParams = ko.utils.extend(routeParams, {view: currentRoute().view});
                          }
                          MessageService.notifyParentIframe(routeParams);
                          currentRoute(routeParams);
                        } else {
                          location.href = '#' + routeParams.request_;
                        }
                      } else {
                        self.dataProvider.logUnauthorizedURLAccessAttempt(routeParams);
                        location.replace(self.dataProvider.getDefaultLocation());
                      }
                    }
                }, function(err) {
                    console.warn(err);
                    LoginService.navigateToLogin(err ? 'Session Expired' : undefined);
                });
            }
        });
    });
    activateCrossroads();
}


function activateCrossroads() {
    function parseHash(newHash) {
        crossroads.parse(newHash);
    }
    crossroads.normalizeFn = crossroads.NORM_AS_OBJECT;

    hasher.initialized.add(parseHash);
    hasher.changed.add(parseHash);
    hasher.init();
}
